import { injectContentsquareScript } from "@contentsquare/tag-sdk";

const CONTENTSQUARE_CLIENT_ID = "37c8749893a76";

let contentsquareLoaded = false;

function loadContentsquare() {
  if (contentsquareLoaded) {
    return;
  }
  contentsquareLoaded = true;
  injectContentsquareScript({ clientId: CONTENTSQUARE_CLIENT_ID, async: true, defer: false });
}

function stopContentsquare() {
  // A running tag can't be removed; reload so the page continues without it.
  if (contentsquareLoaded) {
    globalThis.location.reload();
  }
}

/**
 * Shows the Silktide consent prompt and loads Contentsquare only once the user accepts analytics.
 * Silktide is loaded as a classic script from `index.html`; if it is missing (blocked, failed to load)
 * analytics stays off.
 */
export function initConsentManager() {
  const consentManager = globalThis.window.silktideConsentManager;
  if (!consentManager) {
    return;
  }

  consentManager.init({
    consentTypes: [
      {
        id: "essential",
        label: "Essential",
        description:
          "<p>These cookies and storage are necessary for Evalunity to work and cannot be switched off. They keep you signed in with your Morphotech account, protect your session, remember your privacy choices and save your unsent evaluation drafts on this device.</p>",
        required: true,
      },
      {
        id: "analytics",
        label: "Analytics",
        description:
          "<p>These cookies help us improve Evalunity by understanding how people use it: which pages are visited, where people get stuck and how the app performs. We use Contentsquare for this. Data is aggregated and the content of your evaluations is never recorded.</p>",
        defaultValue: false,
        onAccept: loadContentsquare,
        onReject: stopContentsquare,
      },
    ],
    text: {
      prompt: {
        description:
          "<p>Evalunity uses cookies to keep you signed in and, with your permission, to understand how the app is used so we can improve your review experience.</p>",
        acceptAllButtonText: "Accept all",
        acceptAllButtonAccessibleLabel: "Accept all cookies, including analytics",
        rejectNonEssentialButtonText: "Essential only",
        rejectNonEssentialButtonAccessibleLabel: "Reject analytics cookies and use only essential cookies",
        preferencesButtonText: "Preferences",
        preferencesButtonAccessibleLabel: "Open cookie preferences",
      },
      preferences: {
        title: "Your privacy in Evalunity",
        description:
          "<p>We respect your privacy. Essential cookies are always on because the app needs them. Analytics is optional and you can change your choice at any time from the cookie icon. Your preferences apply across Evalunity on this device.</p>",
        saveButtonText: "Save preferences",
        saveButtonAccessibleLabel: "Save your cookie preferences and close",
        creditLinkText: "Get this banner for free",
        creditLinkAccessibleLabel: "Get this banner for free",
      },
    },
    prompt: { position: "center" },
    icon: { position: "bottomLeft" },
    backdrop: { show: true },
  });
}
